import { Link, NavLink } from 'react-router-dom'
import useFetchMenu from 'Common/FetchAllMenu'
import { SidebarSkeleton } from './SidebarSkeleton '

const HotelTabSidebar = ({ iconColor }) => {
    const { menu: hotelMenu, loading: hotelLoading } = useFetchMenu('hotel');

    if (hotelLoading) {
        return <SidebarSkeleton iconColor={iconColor} />
    }

    const DefaultIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" className="svg-stroke" width="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
            <path d="M12 8m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0" />
            <path d="M8 11a5 5 0 1 0 3.998 1.997" />
            <path d="M12.002 19.003a5 5 0 1 0 3.998 -8.003" />
        </svg>

    );

    return (
        <>
            <h6 className="fl-title title-font ps-2 small Taxt-uppercase Taxt-muted" style={{ "--dynamic-color": "var(--theme-color1)" }}>Universal</h6>
            <ul className={`list-unstyled mb-4 menu-list ${iconColor}`}>
                <li>
                    <NavLink to="/admin/" aria-label="Hotel Dashboard">
                        <svg className="svg-stroke" xmlns="http://www.w3.org/2000/svg" width="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                            <path d="M5 12l-2 0l9 -9l9 9l-2 0"></path>
                            <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7"></path>
                            <path d="M10 12h4v4h-4z"></path>
                        </svg>
                        <span className="mx-3">Dashboard</span>
                    </NavLink>
                </li>
                {/* <li>
                    <NavLink to="/admin/hotels" aria-label="Hotel Front">
                        <svg className="svg-stroke" xmlns="http://www.w3.org/2000/svg" width="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M3 21l18 0" />
                            <path d="M4 21v-11l2.5 -4.5l5.5 -2.5l5.5 2.5l2.5 4.5v11" />
                            <path d="M12 9m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                            <path d="M9 21v-5a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v5" />
                        </svg>
                        <span className="mx-3">Hotels</span>
                    </NavLink>
                </li>
                <li>
                    <NavLink to="/admin/transaction" aria-label="Transaction list">
                        <svg className="svg-stroke" xmlns="http://www.w3.org/2000/svg" width="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                            <path d="M17 8v-3a1 1 0 0 0 -1 -1h-10a2 2 0 0 0 0 4h12a1 1 0 0 1 1 1v3m0 4v3a1 1 0 0 1 -1 1h-12a2 2 0 0 1 -2 -2v-12"></path>
                            <path d="M20 12v4h-4a2 2 0 0 1 0 -4h4"></path>
                        </svg>
                        <span className="mx-3">Transaction</span>
                    </NavLink>

                </li>
                <li>
                    <Link to="#CarbookingMenu" data-bs-toggle="collapse" aria-expanded="false" className="dropdown-toggle" aria-label="Users">
                        <svg xmlns="http://www.w3.org/2000/svg" className="svg-stroke" width="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                            <path d="M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
                            <path d="M5 17h-2v-6l2 -5h9l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-6m-6 -6h15m-6 0v-5" />
                        </svg>
                        <span className="mx-3">Cab Facility</span>
                    </Link>
                    <ul className="collapse list-unstyled" id="CarbookingMenu">
                        <li><NavLink to="/admin/cab-list" aria-label="Cab Details">Cab List</NavLink></li>
                        <li><NavLink to="/admin/cab-booking" aria-label="Cab Booking">Cab Booking</NavLink></li>
                    </ul>
                </li>
                <li>
                    <Link to="#PersonalisedMenu" data-bs-toggle="collapse" aria-expanded="false" className="dropdown-toggle" aria-label="Users">
                        <svg xmlns="http://www.w3.org/2000/svg" className="svg-stroke" width="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M12 8m-5 0a5 5 0 1 0 10 0a5 5 0 1 0 -10 0" />
                            <path d="M8 11a5 5 0 1 0 3.998 1.997" />
                            <path d="M12.002 19.003a5 5 0 1 0 3.998 -8.003" />
                        </svg>
                        <span className="mx-3">Personalised</span>
                    </Link>
                        <ul className="collapse list-unstyled" id="PersonalisedMenu">
                            <li><NavLink to="/admin/personalised-jacuzzi" aria-label="">Jacuzzi</NavLink></li>
                            <li><NavLink to="/admin/personalised-swimmingpool" aria-label="">Swimming pool</NavLink></li>
                            <li><NavLink to="/admin/personalised-spa" aria-label="">Spa</NavLink></li>
                            <li><NavLink to="/admin/personalised-pedicure" aria-label="">Pedicure</NavLink></li>
                            <li><NavLink to="/admin/personalised-theater" aria-label="">Theater</NavLink></li>
                            <li><NavLink to="/admin/personalised-banquet" aria-label="">Banquet</NavLink></li>
                            <li><NavLink to="/admin/personalised-settings" aria-label="">All Settings</NavLink></li>
                        </ul>
                    </li> */}
                {/* For Render Links Without DropDown */}
                {hotelMenu?.map((parent) => {
                    const collapseId = `menu-${parent.menu_id}`;

                    return (
                        <li key={parent.menu_id}>
                            {/* Parent menu (collapse toggle) */}
                            <Link
                                to={`#${collapseId}`}
                                data-bs-toggle="collapse"
                                aria-expanded="false"
                                className="dropdown-toggle d-flex align-items-center"
                                aria-label={parent.menu_title}
                            >
                                {/* Optional icon */}
                                {parent.icon ? (
                                    <span
                                        className="svg-stroke"
                                        dangerouslySetInnerHTML={{ __html: parent.icon }}
                                    />
                                ) : (
                                    <DefaultIcon />
                                )}

                                <span className="mx-3 text-capitalize">
                                    {parent.menu_title}
                                </span>
                            </Link>

                            {/* Child menu */}
                            {parent.children && parent.children.length > 0 && (
                                <ul
                                    className="collapse list-unstyled"
                                    id={collapseId}
                                >
                                    {parent.children.map((child) => (
                                        <li key={child.menu_id}>
                                            <NavLink
                                                to={`/admin/${child.page_url}`}
                                                className="text-capitalize"
                                                aria-label={child.menu_title}
                                            >
                                                {child.menu_title}
                                            </NavLink>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </li>
                    );
                })}

                {/* <li className="py-2 mt-2">
                        <h6 className="fl-title title-font ps-2 small Taxt-uppercase Taxt-muted" style={{ "--dynamic-color": "var(--theme-color1)" }}>Reports</h6>
                        <ul className="list-unstyled">
                            <li><NavLink to="/admin/booking-report" aria-label="Booking Reports">Booking Reports</NavLink></li>
                            <li><NavLink to="/admin/purchase-report" aria-label="Purchase Report">Purchase Reports</NavLink></li>
                            <li><NavLink to="/admin/stock-report" aria-label="Stock Report">Stock Reports</NavLink></li>
                        </ul>
                    </li> */}
            </ul>
        </>

    )
}

export default HotelTabSidebar